import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import logo from "../../assets/imgs/footer/FidyPay-Logo-1024x366.png.png";
import iso from "../../assets/imgs/footer/Frame 1261152719.png";
import iso1 from "../../assets/imgs/footer/Picture.png";
// import certificateISO from "../../assets/pdfs/certificate-iso-2700-2022-Mobile-ID-20241209.pdf";
import termsAndConditionsOfSale from "../../assets/pdfs/terms-and-conditions-of-sale.pdf";
import termsAndConditionsOfService from "../../assets/pdfs/terms-and-conditions-of-service.pdf";
import privacyPolicy from "../../assets/pdfs/trusted-pay-privacy-policy-02.pdf";
import warrantyPolicy from "../../assets/pdfs/warranty-policy.pdf";
import location from "../../assets/svgs/location.svg";
import mail from "../../assets/svgs/mail.svg";
import phone from "../../assets/svgs/phone.svg";
import { LanguageMenu } from "../menu";
import { FooterItem } from "./FooterItem";

const dataFooterItem = {
  quickLinks: [
    { title: "footer.home", link: "/" },
    { title: "footer.about", link: "/about-us" },
    { title: "footer.product", link: "#" },
    { title: "header.contact", link: "/contact" },
  ],
  solutions: [
    { title: "footer.api", link: "/banking" },
    { title: "footer.bbps", link: "/bbps" },
    { title: "footer.prepaid", link: "/prepaid-card" },
    { title: "footer.eNach", link: "/enach" },
    { title: "footer.upi", link: "/upi-qr" },
    { title: "footer.soundbox", link: "/soundbox" },
    { title: "footer.eykc", link: "/ekyc" },
    { title: "footer.pos", link: "/pos-solution" },
  ],
  helpAndSupport: [
    { title: "footer.termsOfService", link: termsAndConditionsOfService },
    { title: "footer.termsOfSale", link: termsAndConditionsOfSale },
    { title: "footer.privacy", link: privacyPolicy },
    { title: "footer.warranty", link: warrantyPolicy },
  ],
  resources: [
    { title: "footer.cusstories", link: "#" },
    { title: "footer.blog", link: "#" },
    { title: "footer.baas", link: "#" },
    { title: "footer.event", link: "#" },
    { title: "footer.media", link: "#" },
  ],
  industries: [
    { title: "footer.education", link: "#" },
    { title: "footer.heath", link: "#" },
    { title: "footer.langding", link: "#" },
    { title: "footer.Govt", link: "#" },
    { title: "footer.Insure", link: "#" },
    { title: "footer.Hrml", link: "#" },
    { title: "footer.market", link: "#" },
    { title: "footer.nbfc", link: "#" },
  ],
};

export const Footer = () => {
  const { t, i18n } = useTranslation();

  const renderFooterItems = (section, target, isRawLink, isNoLanguage) =>
    dataFooterItem[section].map((data, index) => {
      return (
        <FooterItem
          isRawLink={isRawLink}
          key={index}
          url={
            isNoLanguage
              ? data.link
              : `${i18n.language === "en" ? "/en" : "/vi"}${data.link}`
          }
          title={t(data.title)}
          target={target}
        />
      );
    });

  return (
    <>
      <div className="border-b border-solid border-gray-500 bg-[#2B1C50]">
        <div className="mx-auto max-w-[1280px] px-4 py-[30px]">
          <div className="flex items-start gap-[20px] lgmax:flex-col ">
            <div className="grid w-[300px] gap-4 py-[10px] lgmax:w-full">
              <img src={logo} alt="" />
              <div className="grid gap-2 p-2.5 pl-4">
                <div className="flex flex-col gap-[4px]">
                  <div className="flex items-start gap-[12px] ">
                    <img src={location} alt="" />
                    <p className=" ml-[8px] max-w-[303px] text-[14px] font-normal leading-[22px] text-[--color-footer]">
                      {t("footer.address")}
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-[12px]">
                  <img className="ml-[4px]" src={phone} alt="" />
                  <p className="ml-[4px] max-w-[303px] whitespace-pre text-[14px]  font-normal leading-[22px] text-[--color-footer]">
                    <div className="grid">
                      <a href="tel:1900 6884">1900 6884</a>
                      <a href="tel:+84 28 3622 2982">+84 28 3622 2982</a>
                    </div>
                  </p>
                </div>

                <div className="mt-[12px] flex cursor-pointer items-start gap-[12px]">
                  <img className="ml-[4px] " src={mail} alt="" />
                  <a
                    className="ml-[4px]  max-w-[303px] text-[14px] font-normal leading-[22px]  text-[--color-footer] hover:text-[--color-hover]"
                    href="mailto:info@mobile-id.vn"
                  >
                    {t("footer.mail")}
                  </a>
                </div>
              </div>

              <div className="flex ">
                <a
                  href="https://mobile-id.vn/uploads/Mobile-ID-ISO-27001-2022-Certification"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={iso1} alt="" width={100} />
                </a>
                <Link to={"#"} className="hidden">
                  <img src={iso} alt="" width={100} />
                </Link>
              </div>
            </div>
            <div className="w-[300px] py-[10px]  pt-[50px] lgmax:pt-[0]">
              <div className=" flex flex-col ">
                <p className="pb-[30px] text-[18px] font-semibold uppercase text-[--color-footer]">
                  {t("footer.quick")}
                </p>
                <div className="flex flex-col gap-[4px]">
                  {renderFooterItems("quickLinks")}
                </div>
              </div>
            </div>
            <div className="w-[300px] py-[10px] pt-[50px] lgmax:pt-[0]">
              <div className=" flex flex-col ">
                <p className="pb-[30px] text-[18px] font-semibold uppercase text-[--color-footer]">
                  {t("footer.solution")}
                </p>
                <div className="flex flex-col gap-[4px]">
                  {renderFooterItems("solutions")}
                </div>
              </div>
            </div>
            <div className="flex flex-col pt-[50px]">
              <p className="pb-[30px] text-[18px] font-semibold uppercase text-[--color-footer]">
                {t("footer.help")}
              </p>
              <div className="flex flex-col gap-[4px]">
                {renderFooterItems("helpAndSupport", "_blank", true, true)}
              </div>
            </div>
            {/* <div className="w-[300px]  py-[10px] pt-[50px] lgmax:pt-[0]">
              <p className="pb-[20px] text-[18px] font-semibold uppercase text-[--color-footer]">
                {t("footer.certifier")}
              </p>
              <div className="flex ">
                <img src={iso1} alt="" width={100} />
                <img src={iso} alt="" width={100} />
              </div>
            </div> */}
          </div>
        </div>
      </div>

      {/* <div className="hidden border-b border-solid border-gray-500 bg-[#2B1C50]">
        <div className="mx-auto max-w-[1280px] px-2 py-[30px]">
          <div className="flex items-start gap-[30px]  lgmax:flex-col ">
            <div className="w-[300px] py-[10px] pt-[20px] lgmax:pt-[0]">
              <div className=" flex flex-col ">
                <p className="pb-[20px] text-[18px] font-semibold uppercase text-[--color-footer]">
                  {t("footer.get")}
                </p>
                <div className="flex flex-col gap-[4px]  py-[10px] pl-[6px]  pr-[10px] ">
                  <div className="flex items-start gap-[12px] ">
                    <img src={location} alt="" />
                    <a
                      className=" ml-[8px] max-w-[303px] text-[14px] font-normal leading-[22px] text-[--color-footer]"
                      href="/"
                    >
                      {t("footer.address")}
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-[12px]  ">
                  <img className="ml-[4px]" src={phone} alt="" />
                  <a
                    className="ml-[4px] max-w-[303px] whitespace-pre text-[14px]  font-normal leading-[22px] text-[--color-footer]"
                    href="/"
                  >
                    {t("footer.phone")}
                  </a>
                </div>
              </div>
              <div className="mt-[12px] flex cursor-pointer items-start gap-[12px]">
                <img className="ml-[4px] " src={mail} alt="" />
                <a
                  className="ml-[4px]  max-w-[303px] text-[14px] font-normal leading-[22px]  text-[--color-footer] hover:text-[--color-hover]"
                  href="mailto:info@mobile-id.vn"
                >
                  {t("footer.mail")}
                </a>
              </div>
            </div>
            <div className="w-[300px] py-[10px] pt-[20px] lgmax:pt-[0]">
              <div className=" flex flex-col ">
                <p className="pb-[20px] text-[18px] font-semibold uppercase text-[--color-footer]">
                  {t("footer.help")}
                </p>
                <div className="flex flex-col gap-[4px]  p-[10px]">
                  {renderFooterItems("helpAndSupport")}
                </div>
              </div>
            </div>
            <div className="w-[300px] py-[10px] pt-[20px] lgmax:pt-[0]">
              <div className=" flex flex-col ">
                <p className="pb-[20px] text-[18px] font-semibold uppercase text-[--color-footer]">
                  {t("footer.resoureces")}
                </p>
                <div className="flex flex-col gap-[4px]  p-[10px]">
                  {renderFooterItems("resources")}
                </div>
              </div>
            </div>
            <div className="w-[300px] py-[10px] pt-[20px] lgmax:pt-[0]">
              <div className=" flex flex-col ">
                <p className="pb-[20px] text-[18px] font-semibold uppercase text-[--color-footer]">
                  {t("footer.industries")}
                </p>
                <div className="flex flex-col gap-[4px]  p-[10px]">
                  {renderFooterItems("industries")}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <div className="mx-auto flex max-w-[1280px] items-center justify-between py-[13px] pt-[10px] text-sm text-[#3A505F] sm:flex-col md:px-4">
        <div className="flex w-[160px] sm:justify-center ">
          <LanguageMenu />
        </div>
        <div className="flex  sm:flex-col sm:gap-[10px] ">
          <p className="text-[14px] text-[#3D2E7C]">
            Copyright © {new Date().getFullYear() != "2025" ? "2025 - " : ""}{" "}
            {new Date().getFullYear()}{" "}
            <Link
              to={`https://www.mobile-id.vn/${i18n.language === "en" ? "en" : "vi"}`}
              target="_blank"
              rel="noreferrer"
            >
              Mobile-ID
            </Link>
          </p>
          <div className="flex justify-start sm:justify-center">
            <a
              rel="noreferrer"
              target="_blank"
              href={privacyPolicy}
              className="mx-3 cursor-pointer text-[14px] text-[#3D2E7C] hover:underline"
            >
              {t("footer.privacy1")}
            </a>
            <Link
              to={`/${i18n.language === "en" ? "en" : "vi"}/contact`}
              className=" cursor-pointer text-[14px] text-[#3D2E7C] hover:underline mothaibaysaimin:mr-3 "
            >
              {t("footer.contact")}
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};
